import { Component, inject, OnInit, TemplateRef, Type } from '@angular/core';
import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { PopoverOverlayRef } from './popover-overlay-ref';
import { configData, PopoverContent } from './popover-config';
import { popoverAnimations, PopoverAnimationStateEnum, PopoverPositionEnum } from '../../../../../core/enums/utils';

@Component({
  selector: 'dbx-popover',
  standalone: true,
  imports: [NgComponentOutlet, NgTemplateOutlet],
  templateUrl: './popover.component.html',
  styleUrl: './popover.component.scss',
  animations: [popoverAnimations.popoverAnimation],
})
export class PopoverComponent implements OnInit {
  public popoverRef = inject(PopoverOverlayRef);
  public animationState: PopoverAnimationStateEnum = PopoverAnimationStateEnum.Default;
  public configData = configData;

  public templateRefContent: TemplateRef<any> | null = null;
  public componentContent: Type<any> | null = null;
  public content: PopoverContent = null;
  public context?: { close: () => void };

  public PopoverPositionEnum = PopoverPositionEnum;

  ngOnInit(): void {
    this.content = this.popoverRef.popoverData.content;
    if (this.content instanceof TemplateRef) {
      this.templateRefContent = this.content;
      this.context = {
        close: this.popoverRef.close.bind(this.popoverRef),
      };
    } else if (this.content instanceof Type) {
      this.componentContent = this.content;
    }
  }
}
